import { Icon } from '@chakra-ui/react'
import Pencil from '../../../components/Icon/Pencil'
import Colors from '../../../config/colors'
import useItem from './useItem'
import ProductionItem from '../../../models/production_item'

export default function Edition({ item }: { item: ProductionItem }) {
    const openModal = useItem(item)

    return (
        <Icon
            fill={Colors.INFO}
            as={Pencil}
            marginRight={2}
            cursor="pointer"
            onClick={openModal}
        />
    )
}
